import { Component, OnInit, Input } from '@angular/core';
import { ComboNgSelect, ComboPickListViewData } from '../../../core/model/combos';

@Component({
  selector: 'app-pick-list-viewdata',
  templateUrl: './pick-list-viewdata.component.html',
  styleUrls: ['./pick-list-viewdata.component.css']
})
export class PickListViewdataComponent implements OnInit {

  @Input() set data(data: ComboPickListViewData[]) {
    this.allElements = data;
    this.setElements();
   }

  @Input() titleLeft = 'pruebaLeft';
  @Input() titleRight = 'pruebaRight';

  isFilterLeft = false;
  isFilterRight = false;



  allElements: ComboPickListViewData[];
  elementsLeft: ComboNgSelect[] = [];
  elementsRight: ComboNgSelect[] = [];

  elementsSelectLeftSelected: string[];
  elementsSelectRightSelected: string[];
  private elementLeftSelected: ComboNgSelect;
  private elementRightSelected: ComboNgSelect;

  constructor() { }

  ngOnInit() {
  }

  setElements() {
    if (this.allElements) {
      this.elementsLeft = this.allElements.map(element => this.getComboNgSelect(element.ID, element.NOMBRE));
      this.elementsLeft = this.getDistinctData(this.elementsLeft);

      this.elementsRight = this.getRightElements();
      this.elementsRight = this.getDistinctData(this.elementsRight);

      this.isFilterLeft = false;
      this.isFilterRight = false;

      this.elementsSelectRightSelected = [];
      this.elementsSelectLeftSelected = [];
    }
  }
  private getDistinctData(elements: ComboNgSelect[]): ComboNgSelect[] {
    const distinctIds = new Set(elements.map(el => el.ID));

    const combos: ComboNgSelect[] = [];
    distinctIds.forEach(id => {
      combos.push(elements.find(el => el.ID == id));
    });

    return combos;
  }
  private getRightElements(): ComboNgSelect[] {
    const elements: ComboNgSelect[] = [];
    this.allElements.forEach(element => {
      element.elements.forEach(el => {
        elements.push(this.getComboNgSelect(el.ID, el.NOMBRE));
      });
    });
    return [...elements];
  }

  private getComboNgSelect(id: number, nombre: string): ComboNgSelect {
    const combo = new ComboNgSelect();
    combo.ID = id;
    combo.NOMBRE = nombre;
    return combo;
  }

  changeLeft() {
    this.elementRightSelected = undefined;
    this.elementsSelectRightSelected = [];

    if (this.elementLeftSelected && this.elementLeftSelected.ID.toString() == this.elementsSelectLeftSelected[0]) {
      this.elementLeftSelected = undefined;
      this.elementsSelectLeftSelected = [];
      this.setElements();
      return;
    }

    this.elementLeftSelected = this.elementsLeft.find(element => element.ID.toString() == this.elementsSelectLeftSelected[0]);
    this.filterRightByValue(this.elementLeftSelected);
  }

  private filterRightByValue(elementLeftSelected: ComboNgSelect) {
    const element = this.allElements.find(oneElement => oneElement.ID == elementLeftSelected.ID);
    this.elementsRight = element.elements.map(elementRight => this.getComboNgSelect(elementRight.ID, elementRight.NOMBRE));
    this.isFilterRight = true;
  }

  changeRight() {
    this.elementLeftSelected = undefined;
    this.elementsSelectLeftSelected = [];

    if (this.elementRightSelected && this.elementRightSelected.ID.toString() == this.elementsSelectRightSelected[0]) {
      this.elementRightSelected = undefined;
      this.elementsSelectRightSelected = [];
      this.setElements();
      return;
    }

    this.elementRightSelected = this.elementsRight.find(element => element.ID.toString() == this.elementsSelectRightSelected[0]);
    this.filterLeftByValue(this.elementRightSelected);
  }
  private filterLeftByValue(elementRightSelected: ComboNgSelect) {
    const elementsLeft = this.allElements.filter(element => element.elements.some(elementRight => elementRight.ID == elementRightSelected.ID));
    this.elementsLeft = elementsLeft.map(el => this.getComboNgSelect(el.ID, el.NOMBRE));
    this.isFilterLeft = true;
  }

}
